module.exports = __webpack_public_path__ + "img/vpc12.4ae1562.png";